import { TranslatePipe } from '../../filters/translate.pipe';
import { InputDatepickerComponent } from '../../components/input-datepicker/input-datepicker.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-booking-reschedule',
	templateUrl: './modal-booking-reschedule.component.html',
	imports: [ CommonModule, TranslatePipe, InputDatepickerComponent, LoaderOverlayComponent, ItemErrorComponent, FormsModule ]
})
export class ModalBookingRescheduleComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalBookingRescheduleComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.uid = 'mbr-' + Date.now();
		this.vm.booking = this.angularHelperService.copy(this.vm.booking) || {};
		
		var currentScheduleStart = undefined;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.scheduleStart !== currentScheduleStart) {
				currentScheduleStart = this.vm.scheduleStart;
				this.vm.error = undefined;
			}
		}, 300);
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
	handleFormSubmit() {
		this.vm.submitted = true;
		if (!this.vm.booking.scheduledStart || this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		var startTime: any = this.vm.scheduleStart;
		var endTime: any = moment(startTime).add(this.vm.booking.duration || 0, 'minutes');
		var data: any = {
			id: this.vm.booking.id,
			scheduledStart: new Date(startTime),
			scheduledEnd: new Date(endTime),
		};
		
		this.serviceRestServices.rescheduleBooking(data,
			(res) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Bookings.RESCHEDULE + this.vm.booking.id, data);
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Bookings.REINITIALIZE);
				this.handleModalClose();
			}, (err) => {
				var errData: any = err.error && err.error[0] || {};
				this.vm.error = errData.model + '.' + errData.property + '.' + errData.message;
				this.vm.isProcessing = false;
			}
		);
	}
	
}